import styled from 'styled-components';

const TestModeWrapper = styled.div`
    width: 100%;
    text-align: center;
    margin-top:20%;
    color: #EB0A1E;
`;

export default TestModeWrapper;